import { useFormikContext } from 'formik';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { TableIds } from 'src/api/types/misc';
import { Spacer, TableSkeleton } from 'src/common';
import GenericTable, { TableSheetControlLibrary, useControlLibraryColumns } from 'src/components/GenericTable';
import Button from 'src/components/form/Button';
import {
  ControlFrameworkDetailsQuery,
  useControlFrameworkDetailsQuery,
  useControlsRmpCheckQuery,
} from 'src/graphql/_generated';
import { isQueryLoading } from 'src/graphql/client';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import styled from 'styled-components';

const Div = styled.div`
  padding: 0 40px;
`;

export const FromLib = () => {
  const { values, isSubmitting, handleSubmit, setFieldValue } = useFormikContext<{ selected: string[] }>();

  const { data: { controls: rmpControls = [] } = {} } = useControlsRmpCheckQuery();

  const { data, loading, networkStatus } = useControlFrameworkDetailsQuery();
  const isLoading = isQueryLoading({ data, loading, networkStatus });

  const controlLibs = _.chain(data?.controlFrameworks)
    .flatMap('frameworkControls')
    .orderBy(['control_identifier'])
    .value() as ControlFrameworkDetailsQuery['controlFrameworks'][number]['frameworkControls'];

  const { columns, checked, GTColumnSelectAnchorExported, setChecked } = useControlLibraryColumns({
    data: controlLibs,
    isCheckerEnabled: true,
    tableId: TableIds.addControlControlLib,
  });

  useEffect(() => {
    setFieldValue('selected', checked);
  }, [checked]);

  useEffect(() => {
    setChecked(values.selected);
  }, []);

  return (
    <Div>
      {!isLoading ? (
        <>
          <GenericTable
            tableId={TableIds.addControlControlLib}
            data={controlLibs}
            columns={columns}
            GTColumnSelectAnchorExported={GTColumnSelectAnchorExported}
            expandContent={(row) => <TableSheetControlLibrary data={row} />}
            searchable={['framework_controls', 'framework_control_id', 'name', 'FrameworkAuthor']}
            itemHeight={50}
            rowDisabled={(row) =>
              rmpControls.some((item) => (item.frameworkControls || []).some((fc) => fc?.id === row.id))
            }
          />
          <Spacer $px={30} />
          <Button
            primary
            onClick={() => {
              handleSubmit();
              mpEvent(MPEvents.ButtonClick, {
                button: 'Add',
                modal: 'Add RMP modal',
                tags: ['RMP', 'FRAMEWORK'],
              });
            }}
            disabled={!values.selected.length || isSubmitting}
            loading={isSubmitting}
            css="width: 100%;"
            data-cy="btn-add"
          >
            + ADD
          </Button>
        </>
      ) : (
        <TableSkeleton />
      )}
    </Div>
  );
};
